import React from 'react';
import { IIconProps } from '../interfaces';

const AleaArrowRightIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '50',
}) => {
  const width = parseInt(String(size), 10);
  const height = (9 / 12) * width;

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 12 9" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M11.1079 4.6934C11.3032 4.49814 11.3032 4.18155 11.1079 3.98629L7.92597 0.80431C7.73071 0.609048 7.41412 0.609048 7.21886 0.80431C7.0236 0.999572 7.0236 1.31615 7.21886 1.51142L10.0473 4.33984L7.21886 7.16827C7.0236 7.36353 7.0236 7.68012 7.21886 7.87538C7.41412 8.07064 7.73071 8.07064 7.92597 7.87538L11.1079 4.6934ZM0.754395 4.33984V4.83984H10.7544V4.33984V3.83984H0.754395V4.33984Z" 
        fill={color}
      />
    </svg>
  );
};

export default AleaArrowRightIcon;